<template>
  <v-container fluid>
    <v-divider></v-divider>
    <h3 style="width:100%; text-align: center; color:yellow;">{{ stationInfo }} </h3>
    <v-divider></v-divider>
    <v-row 
      v-for="(rowItems, rowIndex) in groupedDashboardItems" 
      :key="rowIndex"
    >
      
      <v-divider></v-divider>
      <v-col 
        v-for="(item, colIndex) in rowItems" 
        :key="colIndex" 
        cols="12" 
        sm="6" 
        md="3"
      >
        <v-card class="pa-3">
          <v-card-title style="text-align: center;">{{ item.title }}</v-card-title>
          <v-card-text class="d-flex justify-center align-center" style="height: 100%">
            <div v-if="item.type === 'circle'">
            <v-progress-circular
              :value="item.value"
              :size="150"
              :width="10"
              :color="item.color"
              rotate="-90"
            >
            <div class="d-flex flex-column align-center">
    <!--v-icon :color="item.color" size="48">{{ item.icon }}</v-icon-->
    <img 
      :src="item.icon" 
      :alt="item.title" 
      class="theme-icon"
      style="
    width: 48px; 
    height: 48px; 
    "
    />
    <span>{{ item.value }} {{ item.unit }}</span>
  </div>
            </v-progress-circular>
          </div>
          <div v-else-if="item.type === 'square-box'">
            <v-card class="square-box" elevation="2" :style="{ border: item.range === '1' ? '8px solid red' : '' }"> 
              <v-card-text> 
                <div class="d-flex flex-column align-center">
                  <span>{{ item.value.split(',')[0] }}</span> 
                  <span>{{ item.value.split(',')[1] }}</span> 
                  <span>{{ item.value.split(',')[2] }}</span> 
                </div> 
              </v-card-text>
            </v-card>
          </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <!--v-row>
      <v-col cols="12">
        <v-card class="pa-3">
          <v-card-title>戰情表-北海岸</v-card-title>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="4">
        <v-card class="pa-3">
          <v-card-title style="text-align: center;">溫度</v-card-title>
          <v-card-text class="d-flex justify-center align-center" style="height: 100%">
            <v-progress-circular
              :value="temperature"
              :size="150"
              :width="10"
              color="red"
              rotate="-90"
            >
              {{ temperature }}°C
            </v-progress-circular>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="4">
        <v-card class="pa-3">
          <v-card-title style="text-align: center;">濕度</v-card-title>
          <v-card-text class="d-flex justify-center align-center" style="height: 100%">
            <v-progress-circular
            :value="humidity"
            :size="150"
            :width="10"
            rotate="-90"
              color="blue">
              {{ humidity }}%
            </v-progress-circular>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="4">
        <v-card class="pa-3">
          <v-card-title style="text-align: center;">降雨機率</v-card-title>
          <v-card-text class="d-flex justify-center align-center" style="height: 100%">
            <v-progress-circular 
            :value="rainRate"
            :size="150"
            :width="10"
              color="green" >
              {{ rainRate }}%
            </v-progress-circular>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    
    <v-row>
      <v-col cols="4">
        <v-card class="pa-3">
          <v-card-title style="text-align: center;">降雨機率</v-card-title>
          <v-card-text class="d-flex justify-center align-center" style="height: 100%">
            <circular-gauge :value="rainRate" :size="150" />
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="4">
        <v-card class="pa-3">
          <v-card-title style="text-align: center;">濕度</v-card-title>
          <v-card-text class="d-flex justify-center align-center" style="height: 100%">
            <circular-gauge :value="humidity" :size="150" :textColor="humidityColor" :strokeColor="humidityColor"/>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="pa-3">
          <v-card-title>人流(前8小時)</v-card-title>
          <v-card-text>
            <LineChart :chartData="lineChartData" :chartOptions="lineChartOptions" />
          </v-card-text>
        </v-card>
      </v-col>
      
    </v-row-->

  </v-container>
</template>

<script>
import { ref , computed} from 'vue';
import CircularGauge from '../components/CircularGauge.vue'; 
import axios from 'axios';
import { LineChart, BarChart } from 'vue-chart-3'
import { Chart, registerables } from 'chart.js'
//import { useStore } from '../stores/mainStore';
Chart.register(...registerables)

const apiUrl = window.config.API_URL;
//const mainStore =  useStore();
export default {
  name: 'BillboardPubic', 
  props: { 
    areaId: 
    { 
      type: Number, 
      required: false, 
    },
  },
  components: { LineChart, BarChart, CircularGauge },
  mounted(){

    const areaId = this.$route.params.areaId || 
    window.location.pathname.split('/').pop();
  
  if (areaId) {
    this.localAreaId = Number(areaId);
    this.fetchDashboardItems()
    this.startPeriodicRefresh()
  }

    console.log('areaId',this.areaId);
    //this.startTimeout();
  },
  watch: {
    areaId: {
      immediate: true,
      handler(newValue) {
        console.log('newValue',newValue);
        //this.currentAreaId = newValue;
        //console.log('currentAreaId',currentAreaId);
      }
    }
  },
  methods:{
      async fetchDashboardItems() {
      try {
        const response = await axios.get(`${apiUrl}/weather/weather?areaid=${this.localAreaId}`);
        //console.log('resp',response.data);
        this.dashboardData=response.data;
        this.stationInfo=this.dashboardData.dataInfo;
        //console.log('1',this.dashboardData.lstWeathers);
        this.dashboardItems=this.dashboardData.lstWeathers;
        //console.log('2',this.dashboardItems);
        
        //this.dashboardItems = response.data;
      } catch (error) {
        console.error('Error fetching dashboard items:', error)
      }
    },
    startPeriodicRefresh() {
      // Stop any existing interval
      if (this.refreshInterval) {
        clearInterval(this.refreshInterval)
      }
      
      // Start new interval
      this.refreshInterval = setInterval(() => {
        this.fetchDashboardItems()
      }, 10000) // Refresh every 30 seconds
    },
    beforeDestroy() {
      this.cancelTimeout(); // Cleanup timeout on component destruction
    },
    
  },
  computed:{
      groupedDashboardItems() {
        console.log('grouped begin');
      try
      {
      const grouped = []
      for (let i = 0; i < this.dashboardItems.length; i += 4) {
        grouped.push(this.dashboardItems.slice(i, i + 4))
      }
      console.log('grouped',grouped);
      return grouped;
    }
    catch(e)
    {
      return null;
    }
  },
},
  
  data() {
    return {
      currentAreaId:0,
      localAreaId:0,
      stationInfo:null,
      refreshInterval: null,
      grouped:[],
      dashboardItems:[],
      dashboardData:null,
      humidityColor:'white',
      timeoutId: null, 
      rainRate:20.0,
      humidity:80.0,
      temperature:19.2,
      lineChartData: {
        labels: ['08', '09', '10', '11', '12', '13', '14', '15'],
        datasets: [
          {
            label: '遊客人數',
            data: [3, 19, 33, 15, 12,38,45,54],
            borderColor: 'rgb(75, 192, 192)',
            tension: 0.1
          }
        ]
      },
      lineChartOptions: {
        responsive: true,
        maintainAspectRatio: false
      },
      barChartData: {
        labels: ['Red', 'Blue', 'Yellow', 'Green', 'Purple'],
        datasets: [
          {
            label: '# of Votes',
            data: [12, 19, 3, 5, 2],
            backgroundColor: [
              'rgba(255, 99, 132, 0.2)',
              'rgba(54, 162, 235, 0.2)',
              'rgba(255, 206, 86, 0.2)',
              'rgba(75, 192, 192, 0.2)',
              'rgba(153, 102, 255, 0.2)'
            ],
            borderColor: [
              'rgba(255, 99, 132, 1)',
              'rgba(54, 162, 235, 1)',
              'rgba(255, 206, 86, 1)',
              'rgba(75, 192, 192, 1)',
              'rgba(153, 102, 255, 1)'
            ],
            borderWidth: 1
          }
        ]
      },
      barChartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          y: {
            beginAtZero: true
          }
        }
      }
    }
  },
  created() {
  
  },
  beforeDestroy() {
     if (this.refreshInterval) {
      clearInterval(this.refreshInterval)
    }
  }
}
//filter: brightness(0) saturate(100%) invert(61%) sepia(14%) saturate(3166%) hue-rotate(176deg) brightness(101%) contrast(101%);
</script>

<style>
.v-progress-circular {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.theme-icon1 {
  width: 48px;
  height: 48px;
  filter: 
    invert(61%)   /* Invert the color */
    sepia(14%)    /* Add some color depth */
    saturate(3166%) 
    hue-rotate(176deg)  /* Shift to blue tones */
    brightness(101%) 
    contrast(101%);
}

.theme-icon0 {
  width: 48px;
  height: 48px;
  filter: 
    invert(0%)    /* Keep the original shape */
    brightness(0) /* Make it completely black first */
    sepia(100%)   /* Add color intensity */
    hue-rotate(180deg)  /* Shift to blue */
    saturate(1000%)     /* Increase color saturation */
    brightness(1.5);    /* Lighten the color */
}

.square-box { 
  display: flex; 
  justify-content: center; 
  align-items: center; 
  height: 150px; 
  width: 180px; 
  border: 8px solid rgba(127, 127, 127, 0.233); 
  box-sizing: border-box; } 
  
  .d-flex { 
    display: flex; 
  } 
  
  .flex-column { 
    flex-direction: column; 
  } 
  .align-center { 
    align-items: center; 
    justify-content: center; 
    text-align: center; 
  }
</style>
